// Predefined add-on feature keys selectable when editing a plan's
// additional_features. Each key has a matching `subscription.<key>` translation.
// Add-ons are changed rarely; this fixed list keeps names translatable.
export const ADDITIONAL_FEATURE_KEYS = [
    'api_integration',
    'daily_suggestion',
    'weekly_suggestion',
    'monthly_new_sellers_suggestion',
    'violation_screenshot',
    'seller_violation_notification',
    'data_history',
    'variant_monitoring',
    'shipping_price',
    'third_party_integrations',
    'marketplace_api',
];
